module.exports = __webpack_public_path__ + "static/media/options.66eb0086.svg";